import { deepExtract } from 'helpers/deep';
import AVAILABILITY_REASONS, { PLAN_DOES_NOT_ALLOW_RESERVATIONS } from 'constants/availability-reasons';
import { AVAILABLE, RESERVED } from 'constants/availability-statuses';
import { CREDITS_TYPES } from 'constants/availability-credits';

export default class SchedulesDeriver {
  static availabilityData(schedule) {
    const { availability = {}, override_availabilities: overrideAvailabilities = [] } = schedule;
    const isTopUp = this.isTopUp(schedule);
    const topUpReason = isTopUp && deepExtract('availability.top_up.purchase.reason', schedule, null);
    const credits = deepExtract('availability.credits', schedule, null);
    const creditsReason = deepExtract('availability.credits_reasons', schedule, [])[0];
    const availableToReserve =
      availability.status === AVAILABLE ||
      isTopUp ||
      overrideAvailabilities.some(override => override.purchase && override.purchase.type === 'purchase-plus');
    const creditsType = deepExtract('availability.credits_type', schedule, null);

    return {
      availableToReserve,
      reasonCannotReserve: this.getReason(schedule) || null,
      reasonCode: availability.reason,
      isPremium: availability.credits_type === CREDITS_TYPES.premium,
      isReserved: this.isReserved(schedule),
      label: availability.label || null,
      creditsReason: topUpReason || creditsReason,
      availableToPurchase: this.isAvailableToPurchase(schedule),
      credits,
      isTopUp,
      creditsType,
    };
  }

  static getReason(schedule) {
    const { availability } = schedule;

    if (this.isAvailableToPurchase(schedule) && availability.reason === PLAN_DOES_NOT_ALLOW_RESERVATIONS) {
      return;
    }

    return AVAILABILITY_REASONS[availability.reason];
  }

  static groupByDay(schedules) {
    return schedules.reduce((memo, schedule) => {
      const startDate = new Date(schedule.starttime * 1e3).toISOString().substring(0, 10);
      if (!memo[startDate]) {
        memo[startDate] = [];
      }

      memo[startDate].push(schedule);

      return memo;
    }, {});
  }

  static isAvailableToPurchase(schedule) {
    const { availability, override_availabilities: overrideAvailabilities = [] } = schedule;
    return !!availability.purchase || overrideAvailabilities.length > 0;
  }

  static isReserved(schedule) {
    return deepExtract('availability.status', schedule) === RESERVED;
  }

  static isTopUp(schedule) {
    const topUp = deepExtract('availability.top_up', schedule, null);
    return !!topUp;
  }
}
